import { DocumentSnapshot, SnapshotOptions } from "firebase/firestore";

export class Puzzle {
    id?: string;
    level: number = 0;
    text: string = "";
    rawText: string = "";
    author: string = "";
    country: string = "";
    era: string = "";
    timeCreated?: Date;
    timeModified?: Date;
}

export const levelConverter = {
    toFirestore: (puzzle: Puzzle) => {
        return {
            level: puzzle?.level,
            text: puzzle?.text,
            raw_text: puzzle?.rawText,
            author: puzzle?.author,
            country: puzzle?.country,
            era: puzzle?.era,
        };
    },
    fromFirestore: (snapshot: DocumentSnapshot, options: SnapshotOptions) => {
        const data = snapshot.data(options);

        let puzzle = new Puzzle();
        puzzle.id = snapshot.id;
        puzzle.level = data?.level;
        puzzle.text = data?.text;
        puzzle.rawText = data?.raw_text;
        puzzle.author = data?.author;
        puzzle.country = data?.country;
        puzzle.era = data?.era;

        if (data?.timeCreated) {
            puzzle.timeCreated = data?.timeCreated.toDate();
        }

        if (data?.timeModified) {
            puzzle.timeModified = data?.timeModified.toDate();
        }

        return puzzle;
    }
};